import { render, staticRenderFns } from "./CreateBudget.vue?vue&type=template&id=2fff87f4"
import script from "./CreateBudget.vue?vue&type=script&lang=js"
export * from "./CreateBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports